import { render, staticRenderFns } from "./Random.vue?vue&type=template&id=1f10fcc0&scoped=true&"
import script from "./Random.vue?vue&type=script&lang=ts&"
export * from "./Random.vue?vue&type=script&lang=ts&"
import style0 from "./Random.vue?vue&type=style&index=0&id=1f10fcc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f10fcc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
